if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              console.log('Quick add modal detected');
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    console.log('Modal closed, rendering cart and opening drawer');
                    this.cart.renderContents(response);
                    // Open cart drawer after modal closes and cart renders
                    setTimeout(() => {
                      const cartDrawer = document.querySelector('cart-drawer');
                      console.log('Cart drawer element:', cartDrawer);
                      if (cartDrawer && typeof cartDrawer.open === 'function') {
                        console.log('Opening cart drawer via open()');
                        cartDrawer.open();
                      } else if (cartDrawer) {
                        console.log('Cart drawer found but no open method, trying click fallback');
                        const cartIcon = document.querySelector('cart-icon-bubble');
                        if (cartIcon) {
                          cartIcon.querySelector('a')?.click();
                        }
                      }
                    }, 100);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log('Regular product page detected');
              this.cart.renderContents(response);
              // Open cart drawer after rendering contents
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                console.log('Cart drawer element:', cartDrawer);
                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  console.log('Opening cart drawer via open()');
                  cartDrawer.open();
                } else if (cartDrawer) {
                  console.log('Cart drawer found but no open method, trying click fallback');
                  const cartIcon = document.querySelector('cart-icon-bubble');
                  if (cartIcon) {
                    cartIcon.querySelector('a')?.click();
                  }
                }
              }, 100);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}